const popup = document.getElementById('popup')
const closeBtn = document.getElementById('popup__close')
const overlay = popup?.querySelector('.popup__overlay')

function dismissPopup() {
  if (popup) {
    popup.classList.add('is-hidden')
    popup.addEventListener('animationend', () => {
      popup.remove()
    }, { once: true })
  }
}

closeBtn?.addEventListener('click', dismissPopup)
overlay?.addEventListener('click', dismissPopup)
